import { render, staticRenderFns } from "./edit-constitute.vue?vue&type=template&id=00fbf7bd&scoped=true&"
import script from "./edit-constitute.vue?vue&type=script&lang=ts&"
export * from "./edit-constitute.vue?vue&type=script&lang=ts&"
import style0 from "./edit-constitute.vue?vue&type=style&index=0&id=00fbf7bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fbf7bd",
  null
  
)

component.options.__file = "edit-constitute.vue"
export default component.exports